<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  // Components
  import { Icon } from "$lib/components/atoms/Icon"

  // Default Prop
  export let value = "Applied value"


  const dispatch = createEventDispatcher();

  function removeFilterClick() {
    dispatch('removefilter', {
      value: value
    });
  }

</script>

<div role="button" class="chip-button">
  <span class="chip-button-text">{value}</span>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <span class="chip-button-icon" on:click={removeFilterClick}><Icon icon="close-fill" size="default"  /></span>
</div>

<style type="text/scss" lang="scss" scoped>
  .chip-button {
    --chip-btn-height: theme("spacing.8"); /* 32px */
    --chip-max-width: 250px;
    @apply inline-flex flex-nowrap items-center flex-shrink-0;
    @apply relative;
    @apply rounded-4xl;
    @apply cursor-pointer;
    @apply text-white bg-gray-900;
    @apply ease-in-out duration-200;
    height: var(--chip-btn-height);
    transition-property: background-color;

    &:hover {
      @apply bg-black;
    }
  }

  .chip-button-text {
    @apply text-xs font-sans font-semibold uppercase tracking-wider;
    @apply whitespace-nowrap;
    @apply ml-5 mr-3;
    @apply overflow-ellipsis overflow-x-hidden;
    max-width: var(--chip-max-width);
  }

  .chip-button-icon {
    @apply inline-flex mr-1;
  }
</style>
